<template>
    <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
    >
        <path d="M12 3v2" />
        <circle cx="12" cy="2.5" r="1" fill="currentColor" stroke="none" />
        <rect x="5" y="6" width="14" height="13" rx="3" />
        <path d="M5 11H3.5v4H5M19 11h1.5v4H19" />
        <circle cx="9" cy="11" r="1.2" fill="currentColor" stroke="none" />
        <circle cx="15" cy="11" r="1.2" fill="currentColor" stroke="none" />
        <path d="M9 15.5h6" />
    </svg>
</template>
